"use strict";var intl,__assign=this&&this.__assign||function(){return __assign=Object.assign||function(e){for(var t,a=1,s=arguments.length;a<s;a++)for(var n in t=arguments[a])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},__assign.apply(this,arguments)};
/**
 * @function setExternalTranslate
 * @description Call this function when creating the <IntlProvider></IntlProvider>
 * @param {Object} intlRef the object returned by createIntl from react-intl
 * @example
 * const cache = createIntlCache();
 * setExternalTranslate(createIntl({
 *      locale: locale,
 *      messages: messages[locale],
 *	}, cache));
 *	@copyright Spordle
 */
function setExternalTranslate(e){intl=e}
/**
 * @function externalTranslate
 * @description
 * Function to translate text outside the context of the app.
 * This fonction takes for granted that {@link setExternalTranslate} was called<br>
 * **NOTE: Try using the `intl.formatMessage`. Only use this as a plan B**
 * @param {string} translateId The index to be translated
 * @param {Object} [options] Object containing indexes and values to be matched with wildcards
 * @param {string} [defaultMessageId] String index to be shown as a default message if the id prop is not valid
 * @example
 * externalTranslate('tournamentSingle.sweetAlert.confirm.title')
 * externalTranslate('misc.priceValue', {price: 999})
 * @returns {string} The string corresponding to the index given in the current language
 * @copyright Spordle
 */
function externalTranslate(e,t,a){return intl.formatMessage({id:e,defaultMessage:a?intl.formatMessage({id:a}):void 0},__assign({},t))}Object.defineProperty(exports,"__esModule",{value:!0}),exports.externalTranslate=exports.setExternalTranslate=void 0,exports.setExternalTranslate=setExternalTranslate,exports.externalTranslate=externalTranslate;